<template>
  <b-overlay :show="showOverlay" rounder="sm">
    <template #overlay v-if="invalid && !isBusy">
      <div class="text-center">
        <p id="expired-label">Your link has expired or was not found.</p>
      </div>
    </template>
    <b-container fluid class="p-3">
      <b-card>
        <b-card-sub-title class="mt-2 mb-3">Tracking Detail</b-card-sub-title>
          <b-row>
            <b-col sm="4" class="mb-3">
              <b-media no-body>
                  <b-media-aside class="mt-2">
                    <b-avatar variant="primary" :size="30">
                      <i class="fa fa-info"></i>
                    </b-avatar>
                  </b-media-aside>
                <b-media-body>
                  <b-card-sub-title class="mb-0 mt-2">
                    ORDER INFO
                  </b-card-sub-title>
                  <table v-if="get(getDataOrder, 'number', false)">
                    <tr>
                      <td>Number</td>
                      <td>:</td>
                      <td>{{ get(getDataOrder, 'number', '') }}</td>
                    </tr>
                    <tr>
                      <td>Type</td>
                      <td>:</td>
                      <td>{{ get(getDataOrder, 'type', '') }}</td>
                    </tr>
                    <tr>
                      <td>Vehicle</td>
                      <td>:</td>
                      <td>{{ getVehicleReg }}</td>
                    </tr>
                  </table>
                </b-media-body>
              </b-media>
            </b-col>
            <b-col sm="4" class="mb-3">
              <b-media no-body>
                  <b-media-aside class="mt-2">
                    <b-avatar variant="success" :size="30">
                      <i class="fa fa-gears"></i>
                    </b-avatar>
                  </b-media-aside>
                <b-media-body>
                  <b-card-sub-title class="mb-0 mt-2">
                    MANUFACTURER INFO
                  </b-card-sub-title>
                  <p class="mb-0">
                    <strong>{{ getManufacturName }} </strong><br>
                    {{ getManufacturAddress }}
                  </p>
                </b-media-body>
              </b-media>
            </b-col>
            <b-col sm="4" class="mb-3">
              <b-media no-body>
                  <b-media-aside class="mt-2">
                    <b-avatar variant="primary" :size="30">
                      <i class="fa fa-users"></i>
                    </b-avatar>
                  </b-media-aside>
                <b-media-body>
                  <b-card-sub-title class="mb-0 mt-2">
                    CUSTOMER INFO
                  </b-card-sub-title>
                  <p class="mb-0">
                    <strong> {{ getCustomerName }} </strong><br>
                    {{ getCustomerAddress }}
                  </p>
                </b-media-body>
              </b-media>
            </b-col>
          </b-row>
        </b-card>
      <b-row>
        <b-col sm="3">
          <b-card>
            <b-card-sub-title class="mt-2 mb-3">Tracking status</b-card-sub-title>
            <Timeline
              ref="timeline"
              :timeline-items="timelineItems"
              :message-when-no-items="messageWhenNoItems"
              order="asc"
              :uniqueTimeline="true"
            />
          </b-card>
        </b-col>
        <b-col sm="9">
          <b-card>
            <l-map
              ref="map"
              :zoom="position.zoom"
              :center="position.center"
              :bounds="bounds"
              v-if="!invalid && !isBusyMap"
            >
              <l-tile-layer :url="position.url" />
              <l-polyline :lat-lngs="coords" :color="position.color" />
              <v-rotated-marker
                v-for="(marker, i) in markers"
                :lat-lng="{lat: marker.lat, lng: marker.lng}"
                :icon="marker.icon"
                :key="`marker-${i}`"
                :rotationAngle="marker.angle"
              >
                <l-popup>
                  <div>
                    {{ marker.location }}
                  </div>
                </l-popup>
              </v-rotated-marker>
            </l-map>
            <div v-else class="vue2leaflet-map">
              <p>Please Wait</p>
            </div>
           </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-modal
      :title="get(order, 'title', '')"
      ref="order_detail"
      width="50%"
      hide-footer
      size="md"
      @hidden="hide_order_detail"
    >
      <div class="container text-md-left">
        <b-row class="mb-2">
          <b-col class="p-0">
            <h5 style="font-weight: bold;">Receiver</h5>
            <p style="margin-bottom: 5px;">{{ get(order, 'detail.name', '-') }}</p>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col class="p-0">
            <h5 style="font-weight: bold;">Notes</h5>
            <p style="margin-bottom: 5px;">{{ get(order, 'detail.metadata.notes', '-') }}</p>
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col md="6" class="p-0">
            <h5 style="font-weight: bold;">Signature</h5>
            <b-img :src="`data:image/png;base64,${get(order, 'detail.signature', '')}`" fluid alt="Responsive image"></b-img>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </b-overlay>
</template>
<script>
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import cloneDeep from 'lodash/cloneDeep';
import L from 'leaflet';
import { LMap, LTileLayer, LPolyline, LPopup } from 'vue2-leaflet';
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker';
import Timeline from 'timeline-vuejs';
import tmsApi from '@/api/tmsApi';
import moment from 'moment';

export default {
  components: {
    LMap,
    LTileLayer,
    LPolyline,
    LPopup,
    'v-rotated-marker': Vue2LeafletRotatedMarker,
    Timeline,
  },
  data() {
    return {
      shipment: {},
      position: {
        url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
        center: [-28.86944, 153.04453],
        marker: {
          manufacturer: {
            type: 'manufacturer',
            lat: '',
            lng: '',
            icon: L.icon({
              iconUrl: 'http://hawk-gps.street-directory.com.au/assets/img/tms/factory.png',
              iconSize: [32, 37],
              iconAnchor: [16, 37],
            }),
            angle: 0,
            location: '',
          },
          customer: {
            type: 'customer',
            lat: '',
            lng: '',
            icon: L.icon({
              iconUrl: 'http://hawk-gps.street-directory.com.au/assets/img/tms/user.png',
              iconSize: [32, 37],
              iconAnchor: [16, 37],
            }),
            angle: 0,
            location: '',
          },
          vehicle: {
            type: 'vehicle',
            lat: '',
            lng: '',
            icon: L.icon({
              iconUrl: 'http://hawk-gps.street-directory.com.au/assets/img/tms/truck-up.png',
              iconSize: [32, 37],
              iconAnchor: [16, 37],
            }),
            angle: 0,
            location: '',
          },
        },
        zoom: 5,
        color: '#3388ff',
        coords: [],
      },
      messageWhenNoItems: 'There\'s No Status',
      timelineItems: [],
      getDataOrder: '',
      getVehicleReg: '',
      getCustomerAddress: '',
      getManufacturAddress: '',
      getManufacturName: '',
      getCustomerName: '',
      isBusy: false,
      isBusyMap: true,
      showOverlay: true,
      tokenStatus: '',
      interval: {
        order: {
          handle: null,
          duration: 3e6,
        },
        position: {
          handle: null,
          duration: 15e3,
        },
      },
      order: {},
    };
  },
  created() {
    this.get_order_status();
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.timeline.$el.querySelectorAll('.show-detail').forEach((el) => {
          el.addEventListener('click', () => {
            this.show_detail_order(el.id.replace('step-', ''));
          });
        });
      }, 2e3);
    });
  },
  methods: {
    get,
    show_detail_order(id) {
      this.order = this.timelineItems.find(item => parseInt(item.index, 10) === parseInt(id, 10));
      this.$refs.order_detail.show();
    },
    hide_order_detail() {
      this.$refs.order_detail.hide();
    },
    get_order_status(init = true) {
      this.isBusy = true;
      tmsApi.get_order_status({ token: this.token })
        .then((resp) => {
          this.tokenStatus = get(resp, 'status', 'FAILED');
          this.getDataOrder = get(resp, 'data', '');
          if (this.invalid && init) {
            this.isBusy = false;
            return;
          }
          this.getVehicleReg = get(resp, 'data.pickup_vehicle.reg_no', '');
          this.getCustomerName = get(resp, 'data.customer.name', '');
          this.getCustomerAddress = get(resp, 'data.customer.location.name', '');
          this.position.marker.customer.location = get(resp, 'data.customer.location.name', '');
          this.position.marker.customer.lat = get(resp, 'data.customer.location.latitude', 0);
          this.position.marker.customer.lng = get(resp, 'data.customer.location.longitude', 0);
          this.getManufacturAddress = get(resp, 'data.manufactur.location.name', '');
          this.getManufacturName = get(resp, 'data.manufactur.name', '');
          this.position.marker.manufacturer.location = get(resp, 'data.manufactur.location.name', '');
          this.position.marker.manufacturer.lat = get(resp, 'data.manufactur.location.latitude', 0);
          this.position.marker.manufacturer.lng = get(resp, 'data.manufactur.location.longitude', 0);
          const steps = get(resp, 'data.steps', []);
          const items = steps.map((step, idx) => {
            const formatedDate = moment(step.datetime).toDate();
            const item = {
              index: idx,
              formatDate: 'DD MMM YYYY HH:mm',
              title: step.name,
              from: new Date(formatedDate),
            };
            if (step.detail) {
              item.detail = step.detail;
              item.description = `<button class="btn btn-sm btn-primary show-detail" id="step-${idx}">Show Detail</button>`;
            }
            return item;
          });
          this.timelineItems = items;
          this.isBusy = false;
          if (init) {
            this.showOverlay = false;
            setTimeout(() => {
              this.get_positions();
            }, 5e2);
          }
        });
    },
    get_positions() {
      const createdAt = get(this.getDataOrder, 'created_at', false);
      if (createdAt) {
        this.isBusyMap = true;
        const payload = {
          token: this.token,
          start: moment(createdAt).format('YYYY-MM-DD HH:mm:ss'),
          end: moment().format('YYYY-MM-DD HH:mm:ss'),
        };
        tmsApi.get_positions(payload)
          .then((resp) => {
            this.position.coords = get(resp, 'data', []);
            setTimeout(() => {
              this.isBusyMap = false;
              this.reload_order_and_position();
            }, 5e2);
          });
      }
    },
    get_realtime_position() {
      tmsApi.get_realtime_position({ token: this.token })
        .then((resp) => {
          if (!isEmpty(resp.data)) {
            const isPositionExists = this.position.coords.find(coord => coord.id === resp.data.id);
            if (!isPositionExists) this.position.coords.push(resp.data);
          }
        });
    },
    reload_order_and_position() {
      const vm = this;
      Object.keys(this.interval).forEach((k) => {
        this.interval[k].handle = setInterval(() => {
          if (k === 'order') {
            vm.get_order_status(false);
          } else {
            vm.get_realtime_position();
          }
        }, this.interval[k].duration);
      });
    },
  },
  computed: {
    token() {
      const check = get(this.$route.query, 'code', '');
      if (isEmpty(check)) {
        return false;
      }
      return check;
    },
    invalid() {
      return this.tokenStatus !== 'SUCCESS' || isEmpty(this.getDataOrder);
    },
    bounds() {
      let bounds = [];
      const filterredCoords = this.position.coords.filter(coord => coord);
      if (filterredCoords.length) {
        const coords = cloneDeep(filterredCoords);
        bounds = L.latLngBounds(coords.map(coord => ({
          lat: coord.alat,
          lng: coord.along,
        })));
      } else {
        bounds = L.latLngBounds([
          {
            lat: this.position.marker.customer.lat,
            lng: this.position.marker.customer.lng,
          },
          {
            lat: this.position.marker.manufacturer.lat,
            lng: this.position.marker.manufacturer.lng,
          },
        ]);
      }
      return bounds;
    },
    coords() {
      return this.position.coords.map(coord =>
        [parseFloat(coord.alat), parseFloat(coord.along)]);
    },
    markers() {
      const validMarkerKeys = Object.keys(this.position.marker).filter((k) => {
        const isNullLat = parseFloat(this.position.marker[k].lat) === 0
          || this.position.marker[k].lat === '';
        const isNullLng = parseFloat(this.position.marker[k].lng) === 0
          || this.position.marker[k].lng === '';
        return !isNullLat && !isNullLng;
      });
      return validMarkerKeys.map(k => this.position.marker[k]);
    },
  },
  watch: {
    'position.coords': function positionCoords(value) {
      if (value.length) {
        const lastIndex = value.length - 1;
        const {
          alat, along, ahead, roadname,
        } = value[lastIndex];
        this.position.marker.vehicle.lat = alat;
        this.position.marker.vehicle.lng = along;
        this.position.marker.vehicle.angle = ahead;
        this.position.marker.vehicle.location = roadname;
      }
    },
  },
};
</script>
<style lang="sass">
@import "~leaflet/dist/leaflet.css";
.full-height
  height: 100vh
.information
  position: absolute
  bottom: 0px
  height: 25vh !important
  width: 100%
  z-index: 1000
  border-top-left-radius: 25px
  border-top-right-radius: 25px
  &--header
    border-top-left-radius: 25px
    border-top-right-radius: 25px
    & .media-body
      text-align: left
  & .card-body
    padding-left: 20px !important
    padding-right: 0px !important
    padding-top: 5px !important
    & .card-header
      background-color: #fff
      border-bottom: 1px dotted
      padding-bottom: 5px
.vue2leaflet-map
  height: 65vh !important
.section-year
  display: none !important
.timeline .wrapper-item
  grid-template-columns: auto 1fr !important
.timeline-item .date-item
  font-size: 14px !important
  letter-spacing: 1px !important
.expired-label
  font-size: 24px
.timeline-item .date-item
  letter-spacing: 0px !important
  text-transform: none !important
</style>



// WEBPACK FOOTER //
// src/views/pages/Tracking.vue